import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1129ad69&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=1129ad69&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=1129ad69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6554cb098e537a9b8e01f1854c0c52c1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129ad69",
  null
  
)

export default component.exports